import { render, staticRenderFns } from "./ProfileWidget.vue?vue&type=template&id=db0a64fa"
import script from "./ProfileWidget.vue?vue&type=script&lang=js"
export * from "./ProfileWidget.vue?vue&type=script&lang=js"
import style0 from "./ProfileWidget.vue?vue&type=style&index=0&id=db0a64fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports